import { BaseController } from '@/api/BaseController';
import { RequestOption, TableData } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { Post } from '@/types/upms/post';
import { API_CONTEXT } from '../config';

export default class operationManualController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<Post>>(
      API_CONTEXT + '/app/operationManual/list',
      params,
      httpOptions,
    );
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<ANY_OBJECT>(API_CONTEXT + '/app/operationManual/add', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/operationManual/delete', params, httpOptions);
  }
}
